const products = [
  {
    id: 1,
    name: "Brown Shirt",
    description: "Brown T-Shirt for Women",
    price: 2799,
    gender: "women",
    type: "shirt",
    img: "https://image.ibb.co/kOhL6k/img1.jpg",
    inCart: false,
    category: "clothes",
    color: 'brown',
    size: 'L',
    count: 0
  },
  {
    id: 2,
    name: "Light Brown Shirt",
    description: "Light Brown Shirt for Women",
    price: 999,
    gender: "women",
    type: "shirt",
    img: "https://image.ibb.co/nNmKz5/img2.jpg",
    inCart: false,
    color: 'light brown',
    category: "clothes",
    size: 'XL',
    count: 0
  },
  {
    id: 3,
    name: "Women Grey Shirt",
    description: "Grey Shirt for Women",
    price: 1799,
    gender: "women",
    type: "shirt",
    img: "https://image.ibb.co/n6iMCQ/img3.jpg",
    inCart: false,
    color: 'grey',
    category: "clothes",
    size: 'XXL',
    count: 0
  },
  {
    id: 4,
    name: "Warm Shirt Women",
    description: "Woolen Hoodie Women",
    price: 1999,
    gender: "women",
    type: "shirt",
    img: "https://image.ibb.co/dVfORk/img4.jpg",
    inCart: false,
    color: 'light brown ',
    category: "clothes",
    size: 'XXL',
    count: 0
  },
  {
    id: 5,
    name: "Women Grey Shirt",
    description: "Light Grey Shirt for Women",
    price: 999,
    gender: "women",
    type: "shirt",
    img: "https://image.ibb.co/jpMxmk/img5.jpg",
    inCart: false,
    color: 'grey',
    category: "clothes",
    size: 'S',
    count: 0
  },
  {
    id: 6,
    name: "Women Red/Brown Shirt",
    description: "Red/Brown Blouse for Women",
    price: 2299,
    gender: "women",
    type: "blouse",
    img: "https://image.ibb.co/mJppz5/img6.jpg",
    inCart: false,
    color: 'red',
    category: "clothes",
    size: 'XS',
    count: 0
  },
  {
    id: 7,
    name: "Dark Grey Shirt Women",
    description: "Dark Grey Shirt for Women",
    price: 2999,
    gender: "women",
    type: "shirt",
    img: "https://image.ibb.co/eZiSmk/img7.jpg",
    inCart: false,
    color: 'grey',
    category: "clothes",
    size: 'L',
    count: 0
  },
  {
    id: 8,
    name: "White Shirt Women",
    description: "White Shirt for Women",
    price: 1799,
    gender: "women",
    type: "shirt",
    img: "https://image.ibb.co/dyCysQ/img8.jpg",
    inCart: false,
    category: "clothes",
    color: 'white',
    size: 'L',
    count: 0
  },
  {
    id: 9,
    name: "Man Brown Shirt",
    description: "Brown Shirt for Men",
    price: 999,
    gender: "men",
    type: "shirt",
    img: "http://media.istockphoto.com/photos/young-man-looks-to-the-side-picture-id184616842?k=6&m=184616842&s=612x612&w=0&h=SmtsffRByKDH4_HtzGY8bWvHgH8o_4epWVPogvfJXnk=",
    inCart: false,
    category: "clothes",
    color: 'brown',
    size: 'XL',
    count: 0
  },
  {
    id: 10,
    name: "No Shoulder Hoodie",
    description: "Hoodie for Women",
    price: 999,
    gender: "women",
    type: "shirt",
    img: "https://image.ibb.co/f6gcK5/img9.jpg",
    inCart: false,
    category: "clothes",
    color: 'light brown',
    size: 'XXL',
    count: 0
  },

  {
    id: 11,
    name: "Man Black Shirt",
    description: "Black T-Shirt for Men",
    price: 799,
    gender: "men",
    type: "shirt",
    img: "http://media.istockphoto.com/photos/smiling-young-man-in-blank-black-tshirt-picture-id464946525?k=6&m=464946525&s=612x612&w=0&h=KAjCFoJGDcFcx8R33Tq1vzqbfixh1XwGpFeiRNoTkRQ=",
    inCart: false,
    color: 'black',
    category: "clothes",
    size: 'S',
    count: 0
  },
  {
    id: 12,
    name: "Man Grey Tanktop",
    description: "Grey Tanktop for Men",
    price: 1799,
    gender: "men",
    type: "shirt",
    img: "http://media.istockphoto.com/photos/portrait-of-young-man-wearing-tshirt-picture-id465207699?k=6&m=465207699&s=612x612&w=0&h=wSacC0bmcrekig1DW8lOwH7y3X0e4R9266-TuivVQJA=",
    inCart: false,
    color: 'grey',
    category: "clothes",
    size: 'M',
    count: 0
  },
  {
    id: 13,
    name: "Man White Shirt",
    description: "White Shirt for Men",
    price: 3199,
    gender: "men",
    type: "shirt",
    img: "http://media.istockphoto.com/photos/young-man-wearing-a-white-shirt-picture-id465331977?k=6&m=465331977&s=612x612&w=0&h=-K3c5eE2dZGmg6d5BrBfxOvcHRP7PwHrylyjuEVjbZo=",
    inCart: false,
    color: 'white',
    category: "clothes",
    size: 'L',
    count: 0
  },
  {
    id: 14,
    name: "Man Brown Shirt",
    description: "Brown Shirt for Men",
    price: 999,
    gender: "men",
    type: "shirt",
    img: "http://media.istockphoto.com/photos/young-man-looks-to-the-side-picture-id184616842?k=6&m=184616842&s=612x612&w=0&h=SmtsffRByKDH4_HtzGY8bWvHgH8o_4epWVPogvfJXnk=",
    inCart: false,
    color: 'brown',
    category: "clothes",
    size: 'M',
    count: 0
  },
  {
    id: 15,
    name: "Black Shirt Men",
    description: "Black Shirt for Men",
    price: 1499,
    gender: "men",
    type: "shirt",
    img: "http://media.istockphoto.com/photos/smiling-man-in-a-black-t-shirt-picture-id520883622?k=6&m=520883622&s=612x612&w=0&h=XuxfQE0EOo_uWqA8SzNJvZ9Vn-sKR_cT4J9GRIudE4U=",
    inCart: false,
    color: 'black',
    category: "clothes",
    size: 'XXL',
    count: 0
  },
  {
    id: 16,
    name: "Man Tanktop",
    description: "Tanktop for Men",
    price: 2799,
    gender: "men",
    type: "shirt",
    img: "http://media.istockphoto.com/photos/portrait-of-young-man-wearing-tshirt-picture-id465207699?k=6&m=465207699&s=612x612&w=0&h=wSacC0bmcrekig1DW8lOwH7y3X0e4R9266-TuivVQJA=",
    inCart: false,
    category: "clothes",
    color: 'grey',
    size: 'L',
    count: 0
  },
  {
    id: 17,
    name: "Man Brown Shirt",
    description: "Brown Shirt for Men",
    price: 999,
    gender: "men",
    type: "shirt",
    img: "http://media.istockphoto.com/photos/young-man-looks-to-the-side-picture-id184616842?k=6&m=184616842&s=612x612&w=0&h=SmtsffRByKDH4_HtzGY8bWvHgH8o_4epWVPogvfJXnk=",
    inCart: false,
    category: "clothes",
    color: 'brown',
    size: 'XS',
    count: 0
  },
  {
    id: 18,
    name: "No Shoulder Hoodie",
    description: "Hoodie for Women",
    price: 999,
    gender: "women",
    type: "shirt",
    img: "https://image.ibb.co/f6gcK5/img9.jpg",
    inCart: false,
    category: "clothes",
    color: 'light brown',
    size: 'L',
    count: 0
  },
  {
    id: 19,
    name: "Man Brown Shirt",
    description: "Brown Shirt for Men",
    price: 999,
    gender: "men",
    type: "shirt",
    img: "http://media.istockphoto.com/photos/young-man-looks-to-the-side-picture-id184616842?k=6&m=184616842&s=612x612&w=0&h=SmtsffRByKDH4_HtzGY8bWvHgH8o_4epWVPogvfJXnk=",
    inCart: false,
    category: "clothes",
    color: 'brown',
    size: 'M',
    count: 0
  },
  {
    id: 20,
    name: "Dark Grey Shirt Women",
    description: "Dark Grey Shirt for Women",
    price: 2999,
    gender: "women",
    type: "shirt",
    img: "https://image.ibb.co/eZiSmk/img7.jpg",
    inCart: false,
    category: "clothes",
    color: 'grey',
    size: 'S',
    count: 0
  },
  {
    id: 21,
    name: "Man Brown Shirt",
    description: "Brown Shirt for Men",
    price: 999,
    gender: "men",
    type: "shirt",
    img: "http://media.istockphoto.com/photos/young-man-looks-to-the-side-picture-id184616842?k=6&m=184616842&s=612x612&w=0&h=SmtsffRByKDH4_HtzGY8bWvHgH8o_4epWVPogvfJXnk=",
    inCart: false,
    category: "clothes",
    color: 'brown',
    size: 'L',
    count: 0
  },
  {
    id: 22,
    name: "Warm Shirt Women",
    description: "Woolen Hoodie Women",
    price: 1999,
    gender: "women",
    type: "shirt",
    img: "https://image.ibb.co/dVfORk/img4.jpg",
    inCart: false,
    category: "clothes",
    color: 'light brown',
    size: 'XXL',
    count: 0
  },
  {
    id: 23,
    name: "Women Grey Shirt",
    description: "Light Grey Shirt for Women",
    price: 999,
    gender: "women",
    type: "shirt",
    img: "https://image.ibb.co/jpMxmk/img5.jpg",
    inCart: false,
    category: "clothes",
    color: 'light brown',
    size: 'S',
    count: 0
  },
  {
    id: 24,
    name: "Women Red/Brown Shirt",
    description: "Red/Brown Blouse for Women",
    price: 2299,
    gender: "women",
    type: "blouse",
    img: "https://image.ibb.co/mJppz5/img6.jpg",
    inCart: false,
    category: "clothes",
    color: 'red',
    size: 'M',
    count: 0
  },
  {
    id: 25,
    name: "Dark Grey Shirt Women",
    description: "Dark Grey Shirt for Women",
    price: 4599,
    gender: "women",
    type: "shirt",
    img: "https://image.ibb.co/eZiSmk/img7.jpg",
    inCart: false,
    category: "clothes",
    color: 'grey',
    size: 'M',
    count: 0
  },
];

export default products;
